import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

function Destinations() {

  const destinationsData = {
    dubai: {
      name: "Dubai",
      flag: "🇦🇪",
      tagline: "City of Dreams",
      description: "Experience futuristic skyscrapers, luxury shopping, stunning architecture, and endless desert adventures in this modern marvel.",
      mainImage: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      places: [
        {
          image: "https://images.unsplash.com/photo-1582672060674-bc2bd808a8b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Burj Khalifa",
          description: "World's tallest building"
        },
        {
          image: "https://images.unsplash.com/photo-1502998732392-615e9b445fa4?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          name: "Dubai Aquarium",
          description: "Underwater world adventure"
        },
        {
          image: "https://images.unsplash.com/photo-1628859017536-c2f1d69f3c84?q=80&w=1237&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          name: "Dubai Frame",
          description: "Golden picture frame landmark"
        },
        {
          image: "https://images.unsplash.com/photo-1667592441284-b590021411e3?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          name: "Museum of the Future",
          description: "Innovation and technology showcase"
        },
        {
          image: "https://images.unsplash.com/photo-1606036858743-c106b6ffbff6?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8YnVyaiUyMGFsJTIwYXJhYnxlbnwwfHwwfHx8MA%3D%3D",
          name: "Burj Al Arab",
          description: "Iconic sail-shaped luxury hotel"
        },
        {
          image: "https://images.unsplash.com/photo-1489493585363-d69421e0edd3?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGR1YmFpJTIwZGVzZXJ0JTIwc2FmYXJpfGVufDB8fDB8fHww",
          name: "Desert Safari",
          description: "Adventure in golden sand dunes"
        },
        {
          image: "https://plus.unsplash.com/premium_photo-1738876553819-d4a0b6716ebb?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8YXlhJTIwdW5pdmVyc2UlMjBkdWJhaXxlbnwwfHwwfHx8MA%3D%3D",
          name: "Aya Universe",
          description: "Immersive digital art experience"
        },
        {
          image: "/images/house-of-hype.jpg",
          name: "House of Hype",
          description: "Street art and culture hub"
        },
        {
          image: "/images/the-view-at-palm.jpg",
          name: "Global Village",
          description: "Cultural and shopping festival"
        },
        {
          image: "https://images.unsplash.com/photo-1588314941393-af1c493f345c?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8ZHViYWklMjBtaXJhY2xlJTIwZ2FyZGVufGVufDB8fDB8fHww",
          name: "Miracle Garden",
          description: "World's largest flower garden"
        },
        {
          image: "https://images.unsplash.com/photo-1691399382216-61468ffb788c?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8ZHViYWklMjBtYXJpbmElMjBjcnVpc2V8ZW58MHx8MHx8fDA%3D",
          name: "Dow Cruise (Marina/Creek)",
          description: "Traditional Arabian boat experience"
        },
        {
          image: "/images/palm.jpg.jpeg",
          name: "The View at Palm",
          description: "Panoramic views from Palm Jumeirah"
        },
        {
          image: "https://images.unsplash.com/photo-1708761719067-bb7630724d68?q=80&w=1548&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          name: "Atlantis Aquaventure",
          description: "Luxury resort and waterpark"
        },
        {
          image: "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=900&auto=format&fit=crop&q=60",
          name: "Ski Dubai",
          description: "Indoor ski resort and snow park"
        },
        {
          image: "/images/dubai-parks-resorts.jpg",
          name: "Dubai Parks & Resorts",
          description: "Ultimate theme park destination"
        },
        {
          image: "/images/dolphin-show.jpg",
          name: "Dolphin Show",
          description: "Spectacular dolphin performances"
        },
        {
          image: "/images/sky-view-glass-slide.jpg",
          name: "Sky View with Glass Slide",
          description: "Glass slide and observation deck experience"
        },
        {
          image: "/images/img-world-adventure.jpg",
          name: "IMG Worlds of Adventure",
          description: "World's largest indoor theme park"
        },
        {
          image: "/images/dubai-city-tour.jpg",
          name: "Dubai City Tour",
          description: "Explore the best of Dubai's iconic landmarks"
        },
        {
          image: "/images/emirates-palace-dubai.jpg",
          name: "Emirates Palace",
          description: "Luxury palace hotel experience"
        },
        {
          image: "/images/blue-water-island.jpg",
          name: "Blue Water Island",
          description: "Waterfront leisure and entertainment hub"
        },
        {
          image: "/images/ain-dubai.jpg",
          name: "Ain Dubai",
          description: "World's largest observation wheel"
        },
        {
          image: "/images/speed-boat-ride.jpg",
          name: "Speed Boat Ride",
          description: "Thrilling high-speed boat adventure"
        },
        {
          image: "/images/sky-diving.jpg",
          name: "Sky Diving",
          description: "Freefall over the Palm Jumeirah"
        },
        {
          image: "/images/scuba-diving.jpg",
          name: "Scuba Diving",
          description: "Explore underwater marine life"
        },
        {
          image: "/images/pre-wedding-photoshoot.jpg",
          name: "Pre Wedding Photoshoot",
          description: "Capture memories at stunning Dubai locations"
        },
        {
          image: "/images/private-party-yacht.jpg",
          name: "Private Party Yacht",
          description: "Exclusive private yacht cruise experience"
        },
        {
          image: "/images/sharing-party-yacht.jpg",
          name: "Sharing Party Yacht",
          description: "Fun group yacht party experience"
        },
        {
          image: "/images/dhow-cruise.jpg",
          name: "Dhow Cruise (Marina/Creek)",
          description: "Traditional cruise along Dubai Marina & Creek"
        },
        {
          image: "/images/gold-souq.jpg",
          name: "Gold Souq",
          description: "World-famous traditional gold market"
        },
        {
          image: "/images/limo-ride.jpg",
          name: "Limo Ride",
          description: "Luxury limousine tour of Dubai"
        },
        {
          image: "/images/cruise-part1.jpg",
          name: "Cruise Sailing",
          cruiseName: "Celestyal Cruise",
          description: "D1: Abu Dhabi → D2: Doha → D3: RAK → D4: Khasab → D5: Abu Dhabi"
        },
        {
          image: "/images/cruise-part2.jpg",
          name: "Cruise Sailing",
          cruiseName: "MSC Euribia Cruise",
          description: "D1: Abu Dhabi → D2: Sir Bani Yas → D3: Dubai → D4: Abu Dhabi"
        }
      ]
    },
    abudhabi: {
      name: "Abu Dhabi",
      flag: "🇦🇪",
      tagline: "Capital of Culture",
      description: "Discover the sophisticated capital of the UAE with stunning mosques, thrilling theme parks, and world-class attractions.",
      mainImage: "https://plus.unsplash.com/premium_photo-1661964095477-fe68b487f700?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHhzZWFyY2h8MXx8YWJ1JTIwZGhhYml8ZW58MHx8MHx8fDA%3D",
      places: [
        {
          image: "https://images.unsplash.com/photo-1567215378181-6ecf3590646f?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8c2hlaWtoJTIwemF5ZWQlMjBncmFuZCUyMG1vc3F1ZXxlbnwwfHwwfHx8MA%3D%3D",
          name: "Sheikh Zayed Grand Mosque",
          description: "Stunning Islamic architecture masterpiece"
        },
        {
          image: "https://images.unsplash.com/photo-1712594720216-186c26656f88?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          name: "Baps Hindu Temple",
          description: "Beautiful modern Hindu temple"
        },
        {
          image: "https://plus.unsplash.com/premium_photo-1697730217428-fa63a4efa669?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8c2Vhd29ybGQlMjBhYnUlMjBkaGFiaXxlbnwwfHwwfHx8MA%3D%3D",
          name: "SeaWorld Abu Dhabi",
          description: "Marine life theme park"
        },
        {
          image: "https://plus.unsplash.com/premium_photo-1668883189361-9c754861dbd6?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8eWFzJTIwaXNsYW5kfGVufDB8fDB8fHww",
          name: "Yas Island",
          description: "Entertainment and leisure destination"
        },
        {
          image: "https://images.unsplash.com/photo-1578152882785-df9744e359e5?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8ZmVycmFyaSUyMHdvcmxkJTIwYWJ1JTIwZGhhYml8ZW58MHx8MHx8fDA%3D",
          name: "Ferrari World",
          description: "High-speed thrills and Ferrari excitement"
        },
        {
          image: "https://images.unsplash.com/photo-1639586385864-a8b5d71684c4?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8YnV0dGVyZmx5JTIwZ2FyZGVuJTIwYWJ1JTIwZGhhYml8ZW58MHx8MHx8fDA%3D",
          name: "The Butterfly Gardens",
          description: "Tropical paradise with exotic butterflies"
        },
        {
          image: "/images/louvre-abu-dhabi.jpg",
          name: "Louvre Abu Dhabi",
          description: "World-class art and civilization museum"
        },
        {
          image: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=900&auto=format&fit=crop&q=60",
          name: "TeamLab Phenomena Abu Dhabi",
          description: "Where Art Comes Alive – Immersive digital art experience"
        },
        {
          image: "/images/abu-dhabi-city-tour.jpg",
          name: "Abu Dhabi City Tour",
          description: "Discover the capital's finest attractions"
        },
        {
          image: "/images/theme-park-abu-dhabi.jpg",
          name: "Theme Parks",
          description: "Thrilling rides and entertainment for all ages"
        },
        {
          image: "/images/emirates-palace-abu-dhabi.jpg",
          name: "Emirates Palace",
          description: "Iconic luxury landmark of Abu Dhabi"
        }
      ]
    },
    oman: {
      name: "Oman",
      flag: "🇴🇲",
      tagline: "Arabian Jewel",
      description: "Explore stunning deserts, pristine coastlines, ancient forts, and authentic Arabian culture in this hidden gem.",
      mainImage: "https://images.unsplash.com/photo-1621680696874-edd80ce57b72?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8T21hbnxlbnwwfHwwfHx8MA%3D%3D",
      places: [
        {
          image: "https://images.unsplash.com/photo-1621680696874-edd80ce57b72?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8bXVzY2F0fGVufDB8fDB8fHww",
          name: "Muscat",
          description: "Capital of culture"
        },
        {
          image: "https://plus.unsplash.com/premium_photo-1724459312010-8be0677d5c87?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8V2FoaWJhJTIwU2FuZHN8ZW58MHx8MHx8fDA%3D",
          name: "Wahiba Sands",
          description: "Desert adventure"
        },
        {
          image: "https://media.istockphoto.com/id/185331013/photo/man-at-nizwa-castle.webp?a=1&b=1&s=612x612&w=0&k=20&c=vVL_Tnb-g7VxWL8goYw8VhbYw7hf4iEe2BrJW_81hCg=",
          name: "Nizwa",
          description: "Ancient capital"
        }
      ]
    },
    saudiarabia: {
      name: "Saudi Arabia",
      flag: "🇸🇦",
      tagline: "Kingdom of Wonders",
      description: "Experience ancient heritage, modern vision, stunning landscapes, and authentic Arabian hospitality.",
      mainImage: "https://images.unsplash.com/photo-1580418827493-f2b22c0a76cb?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8U2F1ZGklMjBhcmFiaWF8ZW58MHx8MHx8fDA%3D",
      places: [
        {
          image: "https://plus.unsplash.com/premium_photo-1661963885635-2b428cedce28?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8Uml5YWRofGVufDB8fDB8fHww",
          name: "Riyadh",
          description: "Modern capital"
        },
        {
          image: "https://plus.unsplash.com/premium_photo-1697729610773-f45142625047?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8QWxVbGF8ZW58MHx8MHx8fDA%3D",
          name: "AlUla",
          description: "Archaeological wonder"
        },
        {
          image: "https://images.unsplash.com/photo-1702562017194-0670440917c8?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8RWRnZSUyMG9mJTIwdGhlJTIwV29ybGR8ZW58MHx8MHx8fDA%3D",
          name: "Edge of the World",
          description: "Dramatic cliffs"
        },
        {
          image: "https://images.unsplash.com/photo-1699954669485-812988f5c2db?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8SmVkZGFofGVufDB8fDB8fHww",
          name: "Jeddah",
          description: "Gateway to Makkah"
        },
        {
          image: "https://plus.unsplash.com/premium_photo-1697729498632-c45b1f66b571?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8RGlyaXlhaHxlbnwwfHwwfHx8MA%3D%3D",
          name: "Diriyah",
          description: "Historic birthplace"
        },
        {
          image: "https://images.unsplash.com/photo-1600891021319-785f2d131e3d?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fEFiaGElMjBzYXVkaSUyMGFyYWJpYXxlbnwwfHwwfHx8MA%3D%3D",
          name: "Abha",
          description: "Mountain retreat"
        },
        {
          image: "https://images.unsplash.com/photo-1625315268749-25175e6df10c?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8VGFpZnxlbnwwfHwwfHx8MA%3D%3D",
          name: "Taif",
          description: "City of roses"
        },
        {
          image: "https://images.unsplash.com/photo-1659698645453-c59301c2376b?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8RmFyYXNhbiUyMElzbGFuZHN8ZW58MHx8MHx8fDA%3D",
          name: "Farasan Islands",
          description: "Marine paradise"
        },
        {
          image: "https://media.istockphoto.com/id/1720136409/photo/the-arab-village-close-najran-asir-region-saudi-arabia.webp?a=1&b=1&s=612x612&w=0&k=20&c=KpH1XLkwGGmYiYQqy7e94wuLpUnVRUW-0OfrBquihPk=",
          name: "Najran",
          description: "Ancient heritage"
        },
        {
          image: "https://plus.unsplash.com/premium_photo-1697730172915-26165f42ffe9?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8TkVPTXxlbnwwfHwwfHx8MA%3D%3D",
          name: "NEOM",
          description: "City of the future"
        }
      ]
    },
    georgia: {
      name: "Georgia",
      flag: "🇬🇪",
      tagline: "Crossroads of Cultures",
      description: "Discover ancient wine traditions, stunning mountain landscapes, and warm hospitality at the crossroads of Europe and Asia.",
      mainImage: "https://images.unsplash.com/photo-1603350576276-24747f7bbf40?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHhzZWFyY2h8M3x8R2VvcmdpYXxlbnwwfHwwfHx8MA%3D%3D",
      places: [
        {
          image: "https://images.unsplash.com/photo-1559787248-5beaa0e086bc?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8VGJpbGlzaXxlbnwwfHwwfHx8MA%3D%3D",
          name: "Tbilisi",
          description: "Historic capital"
        },
        {
          image: "https://images.unsplash.com/photo-1691918781533-53853885e528?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8U3ZhbmV0aXxlbnwwfHwwfHx8MA%3D%3D",
          name: "Svaneti",
          description: "Mountain towers"
        },
        {
          image: "https://images.unsplash.com/photo-1568632102228-b7d3e77459c3?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8S2F6YmVnaXxlbnwwfHwwfHx8MA%3D%3D",
          name: "Kazbegi",
          description: "Caucasus peaks"
        }
      ]
    },
    azerbaijan: {
      name: "Azerbaijan",
      flag: "🇦🇿",
      tagline: "Land of Fire",
      description: "Explore ancient fire temples, modern architecture, and rich cultural heritage in the land of eternal flames.",
      mainImage: "https://images.unsplash.com/photo-1596306499398-8d88944a5ec4?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHhzZWFyY2h8Mnx8QXplcmJhaWphbnxlbnwwfHwwfHx8MA%3D%3D",
      places: [
        {
          image: "https://images.unsplash.com/photo-1596306499398-8d88944a5ec4?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8QmFrdXxlbnwwfHwwfHx8MA%3D%3D",
          name: "Baku",
          description: "Flame Towers city"
        },
        {
          image: "https://media.istockphoto.com/id/1065331770/photo/bursting-the-bubble-mud-volcanoes-with-natural-gas-in-gobustan-famous-landmark-azerbaijan.webp?a=1&b=1&s=612x612&w=0&k=20&c=-00gzxgPbVQdAhmwsSZd6F6RmHNCjgLQUu26yG__7Mg=",
          name: "Gobustan",
          description: "Ancient rock art"
        },
        {
          image: "https://images.unsplash.com/photo-1590588875980-dc6f453e57c9?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8U2hla2l8ZW58MHx8MHx8fDA%3D",
          name: "Sheki",
          description: "Silk Road heritage"
        }
      ]
    },
    srilanka: {
      name: "Sri Lanka",
      flag: "🇱🇰",
      tagline: "Pearl of the Indian Ocean",
      description: "Discover ancient temples, pristine beaches, lush tea plantations, and incredible wildlife in this tropical island paradise.",
      mainImage: "https://images.unsplash.com/photo-1566296314736-6eaac1ca0cb9?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8U3JpJTIwTGFua2F8ZW58MHx8MHx8fDA%3D",
      places: [
        {
          image: "https://images.unsplash.com/photo-1612862862126-865765df2ded?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8U2lnaXJpeWF8ZW58MHx8MHx8fDA%3D",
          name: "Sigiriya",
          description: "Ancient rock fortress"
        },
        {
          image: "https://images.unsplash.com/photo-1665849050332-8d5d7e59afb6?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8S2FuZHl8ZW58MHx8MHx8fDA%3D",
          name: "Kandy",
          description: "Cultural capital"
        },
        {
          image: "https://images.unsplash.com/photo-1566296314736-6eaac1ca0cb9?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8RWxsYXxlbnwwfHwwfHx8MA%3D%3D",
          name: "Ella",
          description: "Tea country paradise"
        },
        {
          image: "https://images.unsplash.com/photo-1565097409498-07e8c3d45f96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Galle",
          description: "Colonial fort city"
        },
        {
          image: "https://images.unsplash.com/photo-1552832230-c0197dd311b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Yala National Park",
          description: "Wildlife sanctuary"
        },
        {
          image: "https://images.unsplash.com/photo-1516483638261-f4dbaf036963?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Unawatuna Beach",
          description: "Golden sandy beaches"
        },
        {
          image: "https://images.unsplash.com/photo-1520175480921-4edfa2983e0f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Dambulla Cave Temple",
          description: "Ancient Buddhist caves"
        },
        {
          image: "https://images.unsplash.com/photo-1578469645742-46cae010e5d4?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Nuwara Eliya",
          description: "Little England"
        }
      ]
    },
    bali: {
      name: "Bali, Indonesia",
      flag: "🇮🇩",
      tagline: "Island Paradise",
      description: "Discover tropical beaches, ancient temples, lush rice terraces, and spiritual experiences in this Indonesian paradise.",
      mainImage: "https://plus.unsplash.com/premium_photo-1677829177642-30def98b0963?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8QmFsaSUyQyUyMEluZG9uZXNpYXxlbnwwfHwwfHx8MA%3D%3D",
      places: [
        {
          image: "https://plus.unsplash.com/premium_photo-1669317566483-d3327adeda10?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8VWJ1ZHxlbnwwfHwwfHx8MA%3D%3D",
          name: "Ubud",
          description: "Cultural heart"
        },
        {
          image: "https://images.unsplash.com/photo-1571984405176-5958bd9ac31d?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8U2VtaW55YWslMjBCZWFjaHxlbnwwfHwwfHx8MA%3D%3D",
          name: "Seminyak Beach",
          description: "Sunset paradise"
        },
        {
          image: "https://images.unsplash.com/photo-1624935851312-845758a99160?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8VGFuYWglMjBMb3R8ZW58MHx8MHx8fDA%3D",
          name: "Tanah Lot",
          description: "Sea temple"
        }
      ]
    },
    thailand: {
      name: "Thailand",
      flag: "🇹🇭",
      tagline: "Land of Smiles",
      description: "Discover vibrant temples, pristine beaches, delicious cuisine, and warm hospitality in Southeast Asia's jewel.",
      mainImage: "https://images.unsplash.com/photo-1528181304800-259b08848526?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHhzZWFyY2h8Mnx8VGhhaWxhbmR8ZW58MHx8MHx8fDA%3D",
      places: [
        {
          image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Bangkok",
          description: "Vibrant capital"
        },
        {
          image: "https://images.unsplash.com/photo-1539650116574-75c0c6d73c6e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Phuket",
          description: "Island paradise"
        },
        {
          image: "https://images.unsplash.com/photo-1565097409498-07e8c3d45f96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Chiang Mai",
          description: "Northern culture"
        }
      ]
    },
    switzerland: {
      name: "Switzerland",
      flag: "🇨🇭",
      tagline: "Alpine Excellence",
      description: "Discover pristine mountain peaks, crystal-clear lakes, and charming villages nestled in breathtaking alpine landscapes.",
      mainImage: "https://images.unsplash.com/photo-1570161766218-f8488ebb8078?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHhzZWFyY2h8Mnx8U3dpdHplcmxhbmR8ZW58MHx8MHx8fDA%3D",
      places: [
        {
          image: "https://images.unsplash.com/photo-1527668752968-14dc70a27c95?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Matterhorn",
          description: "Iconic pyramid peak"
        },
        {
          image: "https://images.unsplash.com/photo-1527668752968-14dc70a27c95?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Jungfraujoch",
          description: "Top of Europe"
        },
        {
          image: "https://images.unsplash.com/photo-1552733407-5d5c46c3bb3b?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Lake Geneva",
          description: "Crystal clear alpine lake"
        },
        {
          image: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Interlaken",
          description: "Adventure sports paradise"
        },
        {
          image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Zermatt",
          description: "Car-free alpine village"
        },
        {
          image: "https://images.unsplash.com/photo-1505142468610-359e7d316be0?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Rhine Falls",
          description: "Europe's most powerful waterfall"
        },
        {
          image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Lucerne",
          description: "Historic lakeside city"
        },
        {
          image: "https://images.unsplash.com/photo-1577896851231-70ef18881754?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Grindelwald",
          description: "Hiking and skiing paradise"
        }
      ]
    },
    japan: {
      name: "Japan",
      flag: "🇯🇵",
      tagline: "Tradition Meets Innovation",
      description: "Experience the perfect harmony of ancient traditions and cutting-edge technology in the land of the rising sun.",
      mainImage: "https://images.unsplash.com/photo-1490806843957-31f4c9a91c65?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      places: [
        {
          image: "https://images.unsplash.com/photo-1526481280693-3bfa7568e0f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Mount Fuji",
          description: "Sacred volcanic peak"
        },
        {
          image: "https://images.unsplash.com/photo-1528164344705-47542687000d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Kyoto Temples",
          description: "Ancient spiritual sites"
        },
        {
          image: "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Tokyo",
          description: "Vibrant metropolis"
        },
        {
          image: "https://images.unsplash.com/photo-1545569341-9eb8b30979d9?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Osaka",
          description: "Food capital of Japan"
        },
        {
          image: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Hiroshima",
          description: "Peace memorial city"
        },
        {
          image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Nara",
          description: "Ancient capital with deer"
        },
        {
          image: "https://images.unsplash.com/photo-1578469645742-46cae010e5d4?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Hakone",
          description: "Hot springs and art"
        },
        {
          image: "https://images.unsplash.com/photo-1554797589-7241bb691973?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Takayama",
          description: "Historic mountain town"
        },
        {
          image: "https://images.unsplash.com/photo-1513407030348-c983a97b98d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Nikko",
          description: "UNESCO World Heritage"
        }
      ]
    },
    armenia: {
      name: "Armenia",
      flag: "🇦🇲",
      tagline: "Ancient Heritage",
      description: "Journey through the world's first Christian nation, with ancient monasteries, stunning landscapes, and rich traditions.",
      mainImage: "https://images.unsplash.com/photo-1531572753322-ad063cecc140?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      places: [
        {
          image: "https://images.unsplash.com/photo-1516483638261-f4dbaf036963?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Yerevan",
          description: "Pink city"
        },
        {
          image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Mount Ararat",
          description: "National symbol"
        },
        {
          image: "https://images.unsplash.com/photo-1565097409498-07e8c3d45f96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Geghard Monastery",
          description: "Rock-carved church"
        }
      ]
    },
    vietnam: {
      name: "Vietnam",
      flag: "🇻🇳",
      tagline: "Timeless Beauty",
      description: "Experience vibrant street life, stunning natural landscapes, delicious cuisine, and rich history from north to south.",
      mainImage: "https://images.unsplash.com/photo-1528127269322-539801943592?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHhzZWFyY2h8Mnx8VmlldG5hbXxlbnwwfHwwfHx8MA%3D%3D",
      places: [
        {
          image: "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Ha Long Bay",
          description: "Limestone karsts"
        },
        {
          image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Ho Chi Minh City",
          description: "Vibrant metropolis"
        },
        {
          image: "https://images.unsplash.com/photo-1565097409498-07e8c3d45f96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Hoi An",
          description: "Ancient trading port"
        }
      ]
    },
    china: {
      name: "China",
      flag: "🇨🇳",
      tagline: "Ancient Wonders",
      description: "Discover millennia of history, stunning landscapes, modern cities, and cultural treasures across this vast nation.",
      mainImage: "https://images.unsplash.com/photo-1547981609-4b6bfe67ca0b?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHhzZWFyY2h8Mnx8Q2hpbmF8ZW58MHx8MHx8fDA%3D",
      places: [
        {
          image: "https://images.unsplash.com/photo-1565097409498-07e8c3d45f96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Great Wall",
          description: "Ancient wonder"
        },
        {
          image: "https://images.unsplash.com/photo-1552832230-c0197dd311b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Beijing",
          description: "Imperial capital"
        },
        {
          image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Shanghai",
          description: "Modern metropolis"
        }
      ]
    },
    france: {
      name: "France",
      flag: "🇫🇷",
      tagline: "Romance & Culture",
      description: "Experience world-renowned cuisine, art, fashion, and romantic landscapes from Paris to Provence.",
      mainImage: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHhzZWFyY2h8Mnx8RnJhbmNlfGVufDB8fDB8fHww",
      places: [
        {
          image: "https://images.unsplash.com/photo-1552832230-c0197dd311b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Paris",
          description: "City of Light"
        },
        {
          image: "https://images.unsplash.com/photo-1516483638261-f4dbaf036963?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "French Riviera",
          description: "Mediterranean glamour"
        },
        {
          image: "https://images.unsplash.com/photo-1531572753322-ad063cecc140?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Provence",
          description: "Lavender fields"
        }
      ]
    },
    maldives: {
      name: "Maldives",
      flag: "🇲🇻",
      tagline: "Tropical Paradise",
      description: "Escape to pristine white beaches, crystal-clear waters, luxury resorts, and world-class diving experiences.",
      mainImage: "https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHhzZWFyY2h8Mnx8TWFsZGl2ZXN8ZW58MHx8MHx8fDA%3D",
      places: [
        {
          image: "https://images.unsplash.com/photo-1539650116574-75c0c6d73c6e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Malé",
          description: "Capital atoll"
        },
        {
          image: "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Baa Atoll",
          description: "UNESCO biosphere"
        },
        {
          image: "https://images.unsplash.com/photo-1565097409498-07e8c3d45f96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Overwater Villas",
          description: "Luxury accommodation"
        }
      ]
    },
    egypt: {
      name: "Egypt",
      flag: "🇪🇬",
      tagline: "Ancient Mysteries",
      description: "Explore ancient pyramids, magnificent temples, the Nile River, and thousands of years of fascinating history.",
      mainImage: "https://plus.unsplash.com/premium_photo-1661891622579-bee76e28c304?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8RWd5cHR8ZW58MHx8MHx8fDA%3D",
      places: [
        {
          image: "https://images.unsplash.com/photo-1552832230-c0197dd311b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Pyramids of Giza",
          description: "Ancient wonders"
        },
        {
          image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Cairo",
          description: "City of pharaohs"
        },
        {
          image: "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Luxor",
          description: "Valley of Kings"
        }
      ]
    },
    southafrica: {
      name: "South Africa",
      flag: "🇿🇦",
      tagline: "Rainbow Nation",
      description: "Experience diverse wildlife, stunning landscapes, vibrant cultures, and world-class wines in the rainbow nation.",
      mainImage: "https://images.unsplash.com/photo-1580060839134-75a5edca2e99?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8U291dGglMjBBZnJpY2F8ZW58MHx8MHx8fDA%3D",
      places: [
        {
          image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Cape Town",
          description: "Mother City"
        },
        {
          image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Kruger National Park",
          description: "Big Five safari"
        },
        {
          image: "https://images.unsplash.com/photo-1565097409498-07e8c3d45f96?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
          name: "Table Mountain",
          description: "Iconic landmark"
        }
      ]
    }
  };

  // Carousel state and functionality
  const [currentSlide, setCurrentSlide] = useState(0);
  const dubaiImages = [
    {
      src: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&h=600&q=80",
      title: "Dubai Skyline",
      description: "Modern marvels reaching for the sky"
    },
    {
      src: "https://images.unsplash.com/photo-1582672060674-bc2bd808a8b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&h=600&q=80",
      title: "Burj Al Arab",
      description: "Iconic sail-shaped luxury"
    },
    {
      src: "https://images.unsplash.com/photo-1518684079-3c830dcef090?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&h=600&q=80",
      title: "Dubai Marina",
      description: "Waterfront living at its finest"
    },
    {
      src: "https://images.unsplash.com/photo-1549180030-48bf079fb38a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&h=600&q=80",
      title: "Dubai Desert Safari",
      description: "Adventure in golden sand dunes"
    },
    {
      src: "https://images.unsplash.com/photo-1596394516093-501ba68a0ba6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&h=600&q=80",
      title: "Dubai Fountain",
      description: "Dancing waters and music"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % dubaiImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + dubaiImages.length) % dubaiImages.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Auto-advance carousel
  useEffect(() => {
    const timer = setInterval(nextSlide, 5000); // Change slide every 5 seconds
    return () => clearInterval(timer);
  }, []);

  const renderCountryCard = (countryKey, data) => {
    const previewPlaces = data.places.slice(0, 3);

    return (
      <div key={countryKey} className="country-card">
        <div className="country-header">
          <img src={data.mainImage} alt={data.name} className="country-main-image" />
          <div className="country-overlay">
            <h3 className="country-name">{data.name}</h3>
            <p className="country-tagline">{data.tagline}</p>
          </div>
        </div>
        <div className="country-places">
          <h4>Top Places to Visit</h4>
          <div className="places-preview">
            <div className="places-grid">
              {previewPlaces.map((place, index) => (
                <div key={index} className="place-item">
                  <img src={place.image} alt={place.name} />
                  <div className="place-info">
                    <h5>{place.name}</h5>
                    <p>{place.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="country-buttons">
              <Link 
                to={`/destinations/${countryKey}`} 
                className="view-details-btn"
              >
                View Details
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  };


  return (
    <div className="page-content">
      <section className="dubai-carousel-section">
        <div className="carousel-container">
          <div className="carousel-header">
            <h2>Discover Dubai</h2>
            <p>Experience the extraordinary</p>
          </div>
          <div className="image-carousel">
            <div className="carousel-track">
              {dubaiImages.map((image, index) => (
                <div 
                  key={index}
                  className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
                >
                  <img src={image.src} alt={image.title} />
                  <div className="slide-content">
                    <h3>{image.title}</h3>
                    <p>{image.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="carousel-nav">
              <button className="nav-btn prev-btn" onClick={prevSlide}>‹</button>
              <button className="nav-btn next-btn" onClick={nextSlide}>›</button>
            </div>
            <div className="carousel-dots">
              {dubaiImages.map((_, index) => (
                <span 
                  key={index}
                  className={`dot ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => goToSlide(index)}
                ></span>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="beautiful-countries">
        <div className="features-container">
          <h2 className="features-title">Most Beautiful Countries to Visit</h2>
          <p className="section-subtitle">Discover breathtaking destinations and their most stunning attractions</p>
          
          <div className="countries-grid">
            {Object.entries(destinationsData).map(([countryKey, data]) => 
              renderCountryCard(countryKey, data)
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Destinations;